module.exports = __webpack_public_path__ + "img/gamma-slide-left.01c40e18.svg";